import { Navigate, useLocation } from "react-router-dom";

import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";

const UnavailableKBProtectedRoute = ({ children }: { children: JSX.Element }) => {
    // Use isAuthenticatedState (reactive) instead of isAuthenticated() (function)
    // This ensures component re-renders when auth state changes
    const { isAuthenticatedState, emailVerified, isTrial, user, knowledgeBase } =
        FirebaseAuthContainer.useContainer();
    const location = useLocation();

    return isAuthenticatedState ? (
        emailVerified &&
        (!isTrial ||
            (knowledgeBase?.expiringTrialPeriod != null &&
                knowledgeBase?.expiringTrialPeriod > 0)) &&
        !!user &&
        !user.currentKnowledgeBaseId ? (
            children
        ) : (
            <Navigate to="/" />
        )
    ) : (
        <Navigate to="/login" state={{ from: location }} />
    );
};

export default UnavailableKBProtectedRoute;
